import Home from '@/components/frame/Home'

const home = {
  isShow: false,
  index: 6,
  path: '/riskWork',
  component: Home,
  redirect: '/riskWork/index',
  name: 'riskWork',
  isHead: true,
  meta: {
    title: '危险作业',
    icon: 'el-icon-position'
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/riskWork/index'),
      name: 'RiskWork',
      meta: { title: '危险作业', close: false }
    }
  ]
}

export default home


// WEBPACK FOOTER //
// ./src/router/modules/riskWork.js